import { useSession } from 'src/apps/invest/common/hooks/useSession';
import React, { useEffect } from 'react';
import { ROUTES } from '../../config';
import { useVerifyAccreditationViewModel } from '../models/VerifyAccreditationViewModel';
import { VerifyAccreditationPage } from '../views/VerifyAccreditationPage';
import { VerifyAccreditationSuccessPage } from '../views/VerifyAccreditationSuccessPage';
import { usePermissions } from '../../common/hooks/usePermissions';
import { Permission } from '@common/permissions';

const sessionRedirect = ROUTES.verifyAccreditation;
const permissions: Permission[] = ['ACCREDITED_INVESTOR', 'UNACCREDITED_INVESTOR'];

export const VerifyAccreditationController: React.FC = () => {
  const { checkAuthenticated } = useSession();
  const { checkPermissions } = usePermissions();

  const viewModel = useVerifyAccreditationViewModel();

  async function init() {
    if (!(await checkAuthenticated(sessionRedirect))) return;
    if (!(await checkPermissions(permissions))) return;
  }

  useEffect(() => {
    init();
  }, []);

  switch (viewModel.page) {
    case 'verify':
      return <VerifyAccreditationPage />;
    case 'success':
      return <VerifyAccreditationSuccessPage />;
  }
};
